<template>
  <div class="race-events">
    <header class="sub">
      <ul class="tabs">
        <li :class="selectedIf('past')"   @click.prevent="setTab('past')">Past</li>
        <li :class="selectedIf('future')" @click.prevent="setTab('future')">Future</li>
      </ul>
      <button class="bar add new-event" :disabled="creating" @click.prevent="createRaceEvent">
        New Event
      </button>
    </header>

    <p v-if="error" class="error">{{ error }}</p>

    <template v-if="settings.raceEventListTab=='future' && raceEventsDisplay.current && raceEventsDisplay.current.length">
      <h1>Live Now</h1>
      <ul>
        <li v-for="re in raceEventsDisplay.current" :key="re.id">
          <race-event-card :race-event="re" @clicked-race="clickedRace"/>
        </li>
      </ul>
    </template>
    
    <template v-if="settings.raceEventListTab == 'future' && raceEventsDisplay.upcoming.length < 1 && raceEventsDisplay.nextUp.length < 1">
      <h1>No Upcoming Events</h1>
    </template>


    <template v-if="settings.raceEventListTab == 'future' && raceEventsDisplay.nextUp.length">
      <h1>{{ dateMs(raceEventsDisplay.nextUp[0].startTime) - Date.now() < (1 * 3600 * 1000) ? 'Live Now' : 'Next Up' }}</h1>
      <div class="next-up">
        <race-event-card
          v-for="re in raceEventsDisplay.nextUp"
          :key="re.id"
          :race-event="re"
          @clicked-race="clickedRace"
        />
      </div>
    </template>
    
    <template v-if="settings.raceEventListTab == 'future' && raceEventsDisplay.upcoming && raceEventsDisplay.upcoming.length">
      <h1>Upcoming Events</h1>
      <ul>
        <li v-for="re in raceEventsDisplay.upcoming" :key="re.id">
          <race-event-card :race-event="re" @clicked-race="clickedRace" />
        </li>
      </ul>
    </template>
    
    <template v-if="settings.raceEventListTab != 'future' && raceEventsDisplay.past">
      <hgroup :class="{'header-group': true, 'show-search': pastSearchVisible}">
        <div class="title">
          <h1>Past Events</h1>
          <button class="round" title="Search past events" @click="showPastSearch">&#xf002;</button>
        </div>
        <search-bar
          ref="pastSearch"
          class="past-search"
          autosave-key="race-events-past"
          placeholder="Search events"
          :participants="[]"
          :show-recent="false"
          :show-result-list="false"
          @query="loadRaceEventsForQuery"
          @complete="pastSearchVisible = false"
          @result-click="clickedRace"
        />
      </hgroup>
      <ul>
        <li v-for="re in raceEventsDisplay.past" :key="re.id">
          <race-event-card :race-event="re" @clicked-race="clickedRace" />
        </li>
        
        <li class="control">
          <loading-spinner v-if="loading" />
          <button @click="loadMoreRaceEvents">Load More</button>
        </li>
      </ul>
    </template>
  </div>
</template>

<style lang="scss">
.race-events {
  color: var(--text-color);
  backdrop-filter: blur(10px);
  max-height: 80vh;
  width: 500px;
  overflow-y: auto;
  
  header.sub { 
    position: sticky;
    z-index: 10;
    background: var(--popover-abgcolor);
//    backdrop-filter: blur(50px);
    border-radius: var(--br);
    top: 0rem;
    left: 0;
    right: 0;
    
    .tabs { margin: 0 auto; }

    .new-event {
      position: absolute;
      right: 0;
    }
  }

  .error {
    color: var(--error-color);
    margin: 0.5rem;
    text-align: center;
  }
  
  >ul,
  .next-up {
    margin: 0;
    padding: 0;
    list-style:none;
  }
  
  .spinner {
    position: fixed !important;
  }
  
  &>h1,
  .header-group h1 {
    text-align: center;
  }

  .header-group {
    display: flex;
    align-items: center;
    gap: 0;
    margin: 0.67em 0.5rem;
    overflow: hidden;

    .title,
    .past-search {
      transition: flex-basis 0.25s ease, opacity 0.2s ease, transform 0.25s ease;
    }

    .title {
      position: relative;
      flex: 0 0 100%;
      min-width: 0;
    }

    h1 {
      margin: 0;
    }

    button.round {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      padding: 0;
    }

    .past-search {
      flex: 0 0 0;
      min-width: 0;
      opacity: 0;
      pointer-events: none;
      transform: translateX(1rem);
    }

    &.show-search {
      padding: 0 0.5rem;
      
      .title {
        flex-basis: 0;
        opacity: 0;
        transform: translateX(-1rem);
      }

      .past-search {
        flex-basis: 100%;
        opacity: 1;
        pointer-events: auto;
        transform: translateX(0);
        border-radius: var(--br);
        border: 1px solid var(--text-dim3-color);

        input {
          color: var(--text-color);
          background: var(--popover-abgcolor);
        }
      }
    }
  }
  
  .race-event-card {
    margin-bottom: 1rem;
    padding: 2px;
  }
  
  .control {
    text-align: center;
    button { width: 50%;}
  }
}

@media screen and (max-width:550px) {
  .race-events {
    width: 88vw;
//    background: red;
    margin: 0;
  }
}

</style>

<script>
  import RaceEventCard from '@/components/race-event-card.vue'
  import SearchBar from '@/components/search-bar.vue'
  import settings from '@/lib/settings.js'
  import schema from '@/schema.js'

  export default {
    name: 'RaceEvents',
    components: { RaceEventCard, SearchBar },
    
    data() {
      return {
        loading: false,
        creating: false,
        error: '',
        raceEventLoadOffset: 0,
        raceEventSearchIds: null,
        raceEventSearchQuery: '',
        raceEventSearchTimer: undefined,
        pastSearchVisible: false,
      }
    },
    
    computed: {
      liveClass() {
        return {
          live: true
        }
      },
      
      raceEvents() {
        if (!this.sharedStore.state.raceEvent)
          return [];

        let events = Object.values(this.sharedStore.state.raceEvent);
        if (this.raceEventSearchIds) {
          events = events.filter(e => this.raceEventSearchIds.includes(e.id));
        }

        return events.sort((a,b)=>{
          a = this.dateMs(a.startTime || a.createdAt, -Infinity);  // createdAt may not be loaded by indexes
          b = this.dateMs(b.startTime || b.createdAt, -Infinity);  // createdAt may not be loaded by indexes
          return b - a;
        });
      },
      
      raceEventsDisplay() {
        if (!this.raceEvents) return {}
      
        let current=[], upcoming = [], past = [];
        const now = Date.now();
                
        for (var i = 0; i < this.raceEvents.length; i++) {
          const e = this.raceEvents[i];
          const deltaSt = e.startTime  ? this.dateMs(e.startTime) - now : 0;
          const deltaCt = e.cutoffTime ? this.dateMs(e.cutoffTime) - now : 0;
          // console.debug(`${i}(now:${now}): ${e.name} ${deltaSt} <-> ${deltaCt}`);
          
          if (deltaSt < 0 && deltaCt > 0) {
            current.push(e);
          }
          else
          if (deltaSt > 0) {
            // Future event
            upcoming.push(e);
          }
          else {
            // Past event
            past.push(e);
          }
          
        }

        upcoming = upcoming.reverse();

        let nextUp = [];
        if (upcoming.length) {
          const nextUpDayStart = this.dateValue(upcoming[0].startTime);
          nextUpDayStart.setHours(0, 0, 0, 0);

          const nextUpDayEnd = new Date(nextUpDayStart);
          nextUpDayEnd.setDate(nextUpDayEnd.getDate() + 1);

          nextUp = upcoming.filter(e => {
            const startTime = this.dateValue(e.startTime);
            return startTime >= nextUpDayStart && startTime < nextUpDayEnd;
          });
          upcoming = upcoming.filter(e => {
            const startTime = this.dateValue(e.startTime);
            return startTime < nextUpDayStart || startTime >= nextUpDayEnd;
          });
        }

        return {
          nextUp,
          upcoming,
          current,
          past,
        }

      },
    },
      
    
    mounted() {
      // console.debug("race-events: mounted and loading");
      // this.loading = true;
      // this.$store.dispatch('loadRaceEvents').then(() => {
      //   this.loading = false;
      // });
    },

    unmounted() {
      clearTimeout(this.raceEventSearchTimer)
    },

    methods: {
      dateValue(value) {
        if (value instanceof Date) return value;
        return value ? new Date(value) : undefined;
      },

      dateMs(value, fallback = 0) {
        const date = this.dateValue(value);
        const ms = date?.getTime();
        return Number.isFinite(ms) ? ms : fallback;
      },

      selectedIf(name) {
        if (name == settings.raceEventListTab) return 'selected'
        return '';
      },
      
      setTab(name) {
        settings.raceEventListTab = name
        this.pastSearchVisible = false
        this.raceEventSearchIds = null
        this.raceEventSearchQuery = ''
      },

      showPastSearch() {
        this.pastSearchVisible = true
        this.$nextTick(() => this.$refs.pastSearch?.$refs.searchbar?.focus())
      },

      loadRaceEventsForQuery(query) {
        clearTimeout(this.raceEventSearchTimer)
        query = query.trim()
        this.raceEventSearchQuery = query
        this.raceEventLoadOffset = 0

        if (!query) {
          this.raceEventSearchIds = null
          return
        }

        this.raceEventSearchTimer = setTimeout(() => {
          this.loading = true
          this.sharedStore.loadRaceEvents({ query }).then(response => {
            if (this.raceEventSearchQuery != query) return
            this.raceEventSearchIds = response.data.map(re => re.id)
          }).finally(() => {
            if (this.raceEventSearchQuery == query) this.loading = false
          })
        }, 300)
      },
      
      clickedRaceEvent(re) {
      },
      
      clickedRace(re, r) {
        console.log("list: clicked", re, r);
        
        const route = r ? {
          name: 'registration',
          params: {
            raceEventId: re.id,
            raceId: r.id,
          },
        } : {
          name: 'raceEvent',
          params: {
            raceEventId: re.id,
          },
        };

        this.$router.push(route);
        this.closeIfInPopover();
      },
      
      loadMoreRaceEvents(e) {
        console.debug(`Loading race events with offset ${this.raceEventLoadOffset + 10}`);
        e && e.preventDefault();

        // Attempt to load the next 10, incrementing our offset tracker upon success.
        this.loading = true;
        // this.$store.dispatch('loadRaceEvents', { offset: this.raceEventLoadOffset + 10}).then(() => {
        //   this.loading = false;
        //   this.raceEventLoadOffset += 10;
        // });

        this.sharedStore.loadRaceEvents({
          offset: this.raceEventLoadOffset + 10,
          query: this.raceEventSearchQuery
        }).then(response => {
          if (this.raceEventSearchQuery) {
            this.raceEventSearchIds = [
              ...(this.raceEventSearchIds || []),
              ...response.data.map(re => re.id)
            ]
          }
          this.loading = false;
          this.raceEventLoadOffset += 10;
        })
      },

      async createRaceEvent(e) {
        e && e.preventDefault();
        if (this.creating) return;

        this.creating = true;
        this.error = '';

        try {
          const response = await this.sharedStore.saveEntity({
            path: '/race_events',
            entity: schema.raceEvent,
            object: {
              name: 'New Event',
              isPublic: false,
            },
          });

          const raceEvent = response?.data;
          if (!raceEvent?.id) {
            throw new Error('The server did not return a race event ID.');
          }

          await this.sharedStore.setActiveRaceEvent(raceEvent.id);
          this.$router.push({
            name: 'raceEvent',
            params: { raceEventId: raceEvent.id },
          });
          this.closeIfInPopover();
        }
        catch (err) {
          console.error('Could not create race event', err);
          this.error = err.response?.data?.error || err.response?.data?.message || err.message || 'Could not create event.';
        }
        finally {
          this.creating = false;
        }
      }
    }
  }
</script>
